import React from 'react'

const Footer = () => {
  return (
    <div style={{ backgroundColor:'#cc0d2e', textAlign:'center' }}>
        <h1 style={{margin:0, padding:'2em 0', fontSize:'18px', color:'#fff', }}>Jollibee | Kingdom of Saudi Arabia | Home of the Famous ChickenJoy!</h1>
    </div>
  )
}

export default Footer